import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChartsLegendItem } from 'components/atoms/charts';

import s from './styles.module.scss';

import type { IPieChartData } from 'components/atoms/charts/types';

interface IProps {
  total: number;
  data: IPieChartData[];
}

const LegendList: React.FC<IProps> = ({ data, total }) => {
  const { t } = useTranslation();

  const getPercent = (val: number) => {
    if (total === 0) return 0;
    return ((val / total) * 100).toFixed(2);
  };

  return (
    <ul className={s.list}>
      <li>{t('labels.legend')}</li>

      {data.map((d, i) => (
        <li key={i}>
          <ChartsLegendItem name={`${d.name} (${d.value})`} color={d.color} />
          {`${getPercent(d.value)}%`}
        </li>
      ))}
    </ul>
  );
};

export default LegendList;
